export default "__VITE_ASSET__LgLBuM87__"